import './node_modules/bootstrap/dist/css/bootstrap.min.css'

import { wrapWithProvider } from './src/context/store'
export const wrapRootElement = wrapWithProvider
